<template>
  <div class="navbar">
    <ul class="navbar-nav site-nav">
      <li class="nav-item hide-md" v-if="userRef">
        <SiteSearch />
      </li>
      <li class="nav-item" v-if="userRef">
        <router-link class="nav-link home" to="/home">
          Home
        </router-link>
      </li>
      <template v-if="props.asDrawer">
        <li class="nav-item">
          <button type="button" class="nav-link" data-bs-toggle="collapse" data-bs-target="#exploreItems">
            Explore
          </button>
        </li>
        <li id="exploreItems" class="collapse">
          <ul class="navbar-nav">
            <li class="nav-item" :class="{ disabled: !exploreStore.enableExploreRef }">
              <router-link class="nav-link" :to="selfProfileRef?.startPersonPageUrl ?? '#'"
                :class="{ disabled: !exploreStore.enableExploreRef }">
                Family
              </router-link>
            </li>
            <li class="nav-item" :class="{ disabled: !exploreStore.enableExploreRef }">
              <router-link class="nav-link" to="/names" :class="{ disabled: !exploreStore.enableExploreRef }">
                Names
              </router-link>
            </li>
            <li class="nav-item disabled">
              <div class="nav-link">
                Places
              </div>
            </li>
          </ul>
        </li>
      </template>
      <template v-else>
        <li class="nav-item dropdown" v-if="selfProfileRef?.startPersonPageUrl">
          <button type="button" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">Explore</button>
          <ul class="dropdown-menu">
            <li class="dropdown-item" :class="{ disabled: !exploreStore.enableExploreRef }">
              <router-link class="link-dark" :to="selfProfileRef?.startPersonPageUrl ?? '#'">
                Family
              </router-link>
            </li>
            <li class="dropdown-item" :class="{ disabled: !exploreStore.enableExploreRef }">
              <router-link class="link-dark" to="/names">
                Names
              </router-link>
            </li>
            <li class="dropdown-item disabled">
              Places
            </li>
          </ul>
        </li>
      </template>
      <li class="nav-item" v-if="!userRef">
        <router-link class="nav-link" to="/plans">
          Plans
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/support">
          Support
        </router-link>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.site-nav {
  font-size: 0.875rem;
}

.navbar-nav .navbar-nav {
  margin-left: 1rem;
}

.navbar-nav .dropdown-menu {
  position: absolute;
}

.nav-link.dropdown-toggle::after {
  display: none;
}

.nav-link.home {
  color: black !important;
}

.dropdown-item.disabled a {
  color: #888 !important;
}

@media (min-width: 768px) {
  .site-nav {
    flex-direction: row;
    gap: 1rem;

    .nav-item > .nav-link:not(:hover) {
      color: #888;
    }
  }
}
</style>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/gp/UserStore'
import { useDataGroupStore } from "@/gp/DataGroupStore"
import { useViewPersonStore } from "@/rd/ViewPersonStore"
import { useExploreStore } from '@/explore/ExploreStore'
import { LoadMode } from '@/util/AsyncData'
import SiteSearch from './SiteSearch.vue'

const props = defineProps<{
  asDrawer?: boolean
}>()

const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()
const exploreStore = useExploreStore()

const userRef = computed(() => userStore.getAsyncSelf(LoadMode.EnsureLoaded)?.data)
const selfProfileRef = computed(() => dataGroupStore.getAsyncGroup(userRef.value?.profileDataGroupId, LoadMode.EnsureLoaded)?.data)
</script>
